import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import Popover from "@mui/material/Popover";
import FeatureGuideLink from "./FeatureGuideLink";

// Click/tap opens a persistent, keyboard-accessible panel so its link can be
// reached without a hover tooltip disappearing as focus or the pointer moves.
export default function FeatureInfo({ title, description, dependency, guide }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const id = React.useId();
  const dismiss = () => setAnchorEl(null);
  return <span className="inline-flex shrink-0">
    <button type="button" aria-label={`About ${title}`} aria-haspopup="dialog" aria-expanded={Boolean(anchorEl)} aria-controls={anchorEl ? id : undefined}
      className="flex h-8 w-8 items-center justify-center rounded text-slate-400 hover:bg-slate-100 hover:text-violet-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-600"
      onClick={(event) => setAnchorEl(event.currentTarget)}>
      <InfoOutlinedIcon style={{ fontSize: 16 }} />
    </button>
    <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={dismiss}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }} marginThreshold={16}
      PaperProps={{ id, role: "dialog", "aria-labelledby": `${id}-title`, "aria-describedby": `${id}-description`, sx: { width: 320, maxWidth: "calc(100vw - 32px)", borderRadius: 2, border: "1px solid #e2e8f0", mt: 0.5 } }}>
      <div className="p-4">
        <div className="mb-2 flex items-start justify-between gap-3">
          <h3 id={`${id}-title`} className="pt-1 text-sm font-semibold text-slate-900">{title}</h3>
          <button type="button" aria-label={`Close ${title} information`} onClick={dismiss}
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded text-slate-500 hover:bg-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-600"><CloseIcon style={{ fontSize: 18 }} /></button>
        </div>
        <p id={`${id}-description`} className="text-sm leading-relaxed text-slate-600">{description}</p>
        {dependency && <p className="mt-3 text-xs leading-relaxed text-slate-500">{dependency}</p>}
        {guide && <div className="mt-3 border-t border-slate-100 pt-2"><FeatureGuideLink guide={guide} /></div>}
      </div>
    </Popover>
  </span>;
}
